<template>
  <v-container fluid px-3>
    <v-layout row wrap>
      <v-flex xs12 v-show="isOrderCollection">
        <v-card>
          <v-card-title primary-title>
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="headline blue--text">Lista de serviços</div>
                </v-flex>
                <v-flex xs12>
                  <v-btn block color="blue darken-2" dark v-on:click="showForm()">Cadastrar Serviço</v-btn> 
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            class="elevation-0"
          >
            <template slot="items" slot-scope="props">
              <tr v-on:click="showForm(props.item)" class="pointer">
                <td>{{ timestampToDate(props.item.created_at) }}</td>
                <td class="text-xs-left">{{ carFor(props.item.car_id) }}</td>
                <td class="text-xs-left">{{ translateStatus(props.item.status) }}</td>
                <td class="text-xs-right">{{ totalFor(props.item.id) }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex xs12 v-if="isOrderRecord || isOrderItemRecord">
        <OrderForm :record="selectedRecord" :cars="cars" :professionals="professionals" />
      </v-flex>
      <v-flex xs12 v-if="(isOrderRecord && !isOrderNewRecord) || isOrderItemRecord">
        <OrderItemList />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OrderForm from "./OrderForm";
import OrderItemList from "./OrderItemList";
import pathToRegexp from 'path-to-regexp'
import utils from '../../shared/Utils'

export default {
  name: "OrderList",
  components: { OrderForm, OrderItemList },
  data () {
    return {
      headers: [
        { text: 'Data', align: 'left', value: 'created_at', sortable: true },
        { text: 'Carro', align: 'left', value: 'car_id', sortable: false },
        { text: 'Situação', value: 'status', align: 'left', sortable: false },
        { text: 'Total', value: 'total_value', align: 'right', sortable: false }
      ],
      items: [],
      items_cars: [],
      items_totals: [],
      cars: [],
      professionals: [],
      selected_item: {},
      loading: false
    }
  },
  mounted() {
    this.loadRecordsIfNeeded()
  },
  computed: {
    selectedRecord() {
      return this.selected_item
    },
    isOrderCollection() {
      return this.checkRoute('/cliente/:id');
    },
    isOrderRecord() {
      return this.checkRoute('/cliente/:id/servico/:service_id');
    },
    isOrderItemRecord() {
      return this.checkRoute('/cliente/:id/servico/:service_id/:item_id');
    },
    isOrderNewRecord() {
      return this.checkRoute('/cliente/:id/servico/novo');
    },
    clientId() {
      const route_check_result = pathToRegexp('/cliente/:id*').exec(this.$route.path)
      return route_check_result === null ? null : (route_check_result[1] == 'novo' ? null : route_check_result[1])
    }
  },
  methods: {
    calculateTotal() {
      let total_cents = 0
      for (let key in this.items_totals) {
        if (this.items_totals[key] && this.items_totals[key].total) {
          total_cents = total_cents + Number(this.items_totals[key].total.split('$').join('').split('.').join(''))
        }
      }
      this.$root.$emit('CUSTOMER_TOTAL_DEBIT', utils.centsToMoney(total_cents))
    },
    totalFor(order_id) {
      return this.items_totals[order_id].total
    },
    carFor(car_id) {
      return `${this.items_cars[car_id].maker} ${this.items_cars[car_id].model} ${this.items_cars[car_id].year}`
    },
    translateStatus(status) {
      return status === 'pending' ? 'Aguardando' :
            (status === 'in_progress' ? 'Em andamento' :
            (status === 'finished' ? 'Finalizado' :
            (status === 'delivered' ? 'Entregue' : status)))
    },
    timestampToDate(ts) {
      const d           = new Date( Date.parse(ts) )
      const day_str     = String(d.getDate()).length === 1 ? '0' + d.getDate() : d.getDate()
      const month_str   = String(d.getMonth()).length === 1 ? '0' + d.getMonth() : d.getMonth()
      const year_str    = d.getFullYear()
      const hours_str   = String(d.getHours()).length === 1 ? '0' + d.getHours() : d.getHours()
      const minutes_str = String(d.getMinutes()).length === 1 ? '0' + d.getMinutes() : d.getMinutes()

      return `${day_str}/${month_str}/${year_str} ${hours_str}:${minutes_str}`
    },
    orderTotalToString(total) {
      return total
    },
    carToString(car_list) {
      return `${car_list[0].maker} ${car_list[0].model} ${car_list[0].year}`
    },
    checkRoute(string_route) {
      return pathToRegexp(string_route).exec(this.$route.path) !== null;
    },
    showForm(order) {
      let order_id
      if (typeof(order) === 'undefined') {
        order_id = 'novo'
        this.selected_item = {
          id: null,
          customer_id: this.clientId,
          professional_id: null,
          car_id: null,
          status: 'pending',
          total_value: 0.0,
          notes: '',
          created_at: Date.now(),
          started_at: null,
          finished_at: null
        }
      } else {
        this.selected_item = order
        order_id = order.id
      }
      this.$router.push({ path: `/cliente/${this.clientId}/servico/${order_id}` })
    },
    loadRecordsIfNeeded() {
      if (this.clientId === null) { return null }

      this.loadCustomerOrders()
      this.loadCustomerCars()
      this.loadBusinessProfessionals()
    },
    loadCustomerOrders() {
      this.loading = true

      let successCallback = (response) => {
        if (response.body.data) {
          this.loading = false
          this.items = response.body.data
          this.items_cars = response.body.cars
          this.items_totals = response.body.totals
          this.calculateTotal()
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      this.$root.$emit('CUSTOMER_TOTAL_DEBIT', null)

      this.$http.get(`${this.$root.base_url}/customers/${this.clientId}/orders`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
    },
    loadCustomerCars() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.cars = response.body.data
          this.$root.$emit('CUSTOMER_CARS_LOADED', this.cars)
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      this.$http.get(`${this.$root.base_url}/customers/${this.clientId}/cars`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
    },
    loadBusinessProfessionals() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.professionals = response.body.data
        }
      }

      let errorCallback = (response) => {
        debugger
      }

      let business_id = this.$cookies.get('business_id')

      this.$http.get(`${this.$root.base_url}/business/${business_id}/professionals`, { headers: { Token: this.$cookies.get('api_token') } }).then(successCallback, errorCallback)
    }
  },
  watch: {
    '$route' (to, from) {
      this.loadRecordsIfNeeded()
    }
  }
};
</script>

<style>
 .pointer {
   cursor: pointer;
 }
</style>



// WEBPACK FOOTER //
// src/components/mecanica/OrderList.vue